// 招商码 option
import store from '@/store';
export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  addBtnText: '新增招商码',
  addTitle: '新增招商码',
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchSpan:12,
  searchLabelWidth: 100,
  border: true,
  index: false,
  menu: true,
  indexLabel: '序号',
  selection: false,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  column: [
    {
      label: '招商码编号',
      prop: 'managerCode',
      type: 'input',
    },
    {
      label: '招商经理',
      prop: 'managerName',
      type: 'input',
      display:false
    },
  ],
};

// 招商码
export const codeColumn =[{
    label: '角色',
    prop: 'roleName',
    type: 'input',
    display:false
  },
  {
    label: '扫码次数',
    prop: 'scanCount',
    type: 'input',
    display:false
  },
  {
    label: '招商数量',
    prop: 'investmentCount',
    type: 'input',
    display:false
  },
  {
    label: '创建日期',
    prop: 'createTime',
    minWidth:180,
    type: 'input',
    display:false
  },
  {
    label: '是否启用',
    prop: 'isEnabled',
    type: 'radio',
    display:false,
    slot:true,
  }
]

// 招商记录
export const recordColumn =[
  // {
  //     label: '所属代理商',
  //     prop: 'deptIds',
  //     type: 'select',
  //     filterable: true,
  //     multiple: true,
  //     search: true,
  //     searchOrder: 1000,
  //     hide: true,
  //     dicData: store.getters.companies,
  //     props: {
  //         label: 'title',
  //         value: 'id',
  //     },
  //     display: false,
  // },

  {
    label: '申请人',
    prop: 'legalPersonNme',
    type: 'input',
    display:false
  },
  {
    label: '所属代理商',
    prop: 'agentShortName',
    display: false,
    hide: true,
    search: true,
    searchOrder: 999
  },
  {
    label: '所属代理商',
    prop: 'deptName',
    type: 'input',
    display:false,
  },
  {
    label: '产品类型',
    prop: 'rentType',
    type: 'select',
    display:false,
    hide: true,
    search: true,
    searchOrder: 999,
    dicData: store.getters.porductTypes,
  },
  {
    label: '产品类型',
    prop: 'productName',
    display:false,
    search: false,
    hide: false
  },
  {
    label: '申请日期',
    prop: 'createTime',
    type: 'input',
    display:false
  },
  {
    label: '完成日期',
    prop: 'updateTime',
    type: 'input',
    display:false
  }
]

// 查看代理商
export const agentColumn = {
  height: '450px',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  editBtnText: '编辑代理商',
  editTitle: '编辑代理商',
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchSpan:12,
  border: true,
  index: false,
  menu: true,
  indexLabel: '序号',
  selection: false,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  column:[
    {
      label: '招商码编号',
      prop: 'managerCode',
      // type: 'input',
      type: 'select',
      labelWidth: 110,
      props: {
        label: 'managerCode',
        value: 'id'
      },
      dicData: [],
      rules: [
        {
          required: true,
          message: "请选择招商码编号",
          trigger: "blur"
        }
      ]
    },
    {
      label: '代理商名称',
      prop: 'deptName',
      type: 'input',
      display:false,
    },
    {
      label: '负责人',
      prop: 'principalName',
      type: 'input',
      display:false,
    },
    {
      label: '手机号码',
      prop: 'principalMobile',
      type: 'input',
      display:false,
    },
    {
      label: '开通城市',
      prop: 'cityOpened',
      type: 'input',
      display:false,
    },
    {
      label: '开通产品',
      prop: 'productName',
      type: 'select',
      display:false,
    },
    {
      label: '角色',
      prop: 'roleName',
      type: 'input',
      display:true,
      hide: true,
      editDisabled: true,
    },
    {
      label: '招商经理',
      prop: 'managerName',
      type: 'input',
      display:true,
      hide: true,
      editDisabled: true,
    },
  ]
}
